<mbs-wizard
  class="mbs-wizard_flex-content"
  [buttonLoadingMode]="true"
  [canClosed]="!loadingPlan && wizardFinish"
  [firstStepTitle]="mainService.firstStepTitle"
  [ignoreSteps]="isEdit || !loadingPlan ? [backupToRestoreTitle] : []"
  [isOpenSteps]="!loadingPlan && isEdit"
  [loading]="loadingPlan"
  [scrollableStepContent]="true"
  [stepQueue]="stepsManager.stepQueue"
  [stepsContainerClass]="mainService.isOffline ? 'overflow-hidden' : ''"
  [stepsOrientation]="orientations"
  [title]="wizardTitle + ' ' + mainService.compName + ' | ' + (FormModel?.planNameStep?.Name || '')"
  [(ngModel)]="stepsManager.currentStep"
  (closeModalEvent)="handleModalClose()"
  (save)="handleSave()">
  <div
    *ngIf="mainService.isOffline"
    class="pl-4 py-2 background-secondary"
    prependStep>
    <span class="fa fa-power-off"></span> {{ prependStepText }}
  </div>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.welcome"
    [title]="'wizards:welcome' | i18next"
    [valid]="FormModel?.planNameStep?.valid"
    (next)="planNameStep?.forceValid()">
    <mbs-plan-name-step
      #planNameStep
      [planTypeText]="planTypeText"
      [(ngModel)]="FormModel.planNameStep"
      (copyPlan)="handleCopyRAWPlan()"
      (restoreOnce)="restoreOnceHandler($event)"></mbs-plan-name-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.storage"
    [title]="'wizards:whereBackup.where_backup_title' | i18next"
    [valid]="FormModel?.whereBackupStep?.valid"
    (next)="whereBackupStep?.forceValid()">
    <mbs-where-backup-step
      #whereBackupStep
      [Storages]="FormModel?.Storages"
      [(ngModel)]="FormModel.whereBackupStep"
      (changeStorage)="storageManager.changeStorageHandler($event)"></mbs-where-backup-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectComputer"
    [title]="'wizards:computers_to_restore_title' | i18next"
    [valid]="FormModel?.computerToRestoreStep?.valid"
    (next)="computerToRestore?.forceValid()">
    <mbs-select-computer-step
      #computerToRestore
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:computers_to_restore_title' | i18next)"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.computerToRestoreStep"
      (loadInfo)="loadInfoHandler($event)"></mbs-select-computer-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectBackup"
    [title]="backupToRestoreTitle"
    [valid]="FormModel?.backupToRestoreStep?.valid">
    <mbs-backup-to-restore-step
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.backupToRestoreStep"
      (loadInfo)="loadInfoHandler($event)"></mbs-backup-to-restore-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectPoint"
    [title]="restorePointTitle"
    [valid]="FormModel?.restorePointStep?.valid"
    (next)="restorePointStep?.forceValid(stepsManager.currentStep)">
    <mbs-restore-point-step
      #restorePointStep
      [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.restorePointStep"
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'restorePointStep', restorePointTitle)"></mbs-restore-point-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    *ngIf="isRestoreDatabase"
    [documentationLink]="helpLink.links.instance"
    [title]="serverInstanceTitle"
    [valid]="FormModel?.sqlServerInstanceStep?.valid"
    (next)="sqlServerInstance?.forceValid(stepsManager.currentStep)">
    <mbs-sql-server-instance-step
      #sqlServerInstance
      [databaseServerInstances]="getInstances"
      [(ngModel)]="FormModel.sqlServerInstanceStep"
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'sqlServerInstanceStep', serverInstanceTitle)"></mbs-sql-server-instance-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.source"
    [title]="'wizards:restore_source_title' | i18next"
    [valid]="FormModel?.restoreSourceStep?.valid"
    (next)="restoreSourceStep?.forceValid()">
    <mbs-restore-source-step
      #restoreSourceStep
      [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [mainLoading]="loadingPlan"
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:restore_source_title' | i18next)"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.restoreSourceStep"
      (loadInfo)="loadInfoHandler($event)"></mbs-restore-source-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.destination"
    [title]="'wizards:destinationOld.dest_step_title' | i18next"
    [valid]="FormModel?.destinationStep?.valid"
    (next)="destinationStep?.forceValid()">
    <mbs-destination-db-step
      #destinationStep
      [(ngModel)]="FormModel.destinationStep"></mbs-destination-db-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    *ngIf="!isNBF || FormModel?.restorePointStep?.resultPoint?.IsEncrypted || FormModel?.restorePointStep?.resultPoint?.isEncrypted"
    [documentationLink]="helpLink.links.encryption"
    [title]="stepsManager.titles.encryptionOption"
    [valid]="FormModel?.encryptionOptionsStep?.valid"
    (next)="encryptionOptionsStep?.forceValid(stepsManager.currentStep)">
    <mbs-encryption-options-step
      #encryptionOptionsStep
      [backupToRestore]="FormModel?.backupToRestoreStep?.selectedBunch"
      [resultPoint]="FormModel?.restorePointStep?.resultPoint"
      [(ngModel)]="FormModel.encryptionOptionsStep"
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="
        forceNextStepWizard(!!$event, 'encryptionOptionsStep', stepsManager.titles.encryptionOption)
      "></mbs-encryption-options-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="FormModel.planNameStep.SavePlanInCloud && !isRDMode"
    [documentationLink]="helpLink.links.schedule"
    [title]="stepsManager.titles.schedule"
    [valid]="FormModel?.scheduleStep?.valid"
    (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
    <mbs-schedule-step
      #scheduleStep
      [isGFSMode]="isGFSMode"
      [retentionTitle]="stepsManager.titles.retention"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
      [(ngModel)]="FormModel.scheduleStep"
      (changeType)="scheduleTypeChangeHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
      (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)"
      (unregisterRequiredStep)="stepsManager.stepQueue.unregisterRequiredStep($event)"></mbs-schedule-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="!isRDMode && FormModel?.scheduleStep?.ScheduleType === 'recurring'"
    [documentationLink]="helpLink.links.schedule"
    [title]="'wizards:advanced_schedule_restore_title' | i18next"
    [valid]="FormModel.scheduleAdvancedStep.valid"
    (next)="scheduleAdvancedStep?.forceValid()">
    <mbs-schedule-advanced-step
      #scheduleAdvancedStep
      [(ngModel)]="FormModel.scheduleAdvancedStep"></mbs-schedule-advanced-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="(!isUnix || isNetBuild) && (mainService.allowPrePostActions | async)"
    [documentationLink]="helpLink.links.prePost"
    [title]="
      (mainService.allowPrePostActions | async) ? ('wizards:pre_post_title' | i18next) : ('wizards:pre_post_title_backup_chain' | i18next)
    "
    [valid]="FormModel?.prePostActionsStep?.valid"
    (next)="prePostActionsStep?.forceValid()">
    <mbs-pre-post-actions-step
      #prePostActionsStep
      [ChainPlans]="FormModel?.AvailableMachinePlans"
      [(ngModel)]="FormModel.prePostActionsStep"></mbs-pre-post-actions-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="!isRDMode"
    [documentationLink]="helpLink.links.notification"
    [title]="'wizards:notification_step_title' | i18next"
    [valid]="FormModel?.notificationStep?.valid">
    <mbs-notifications-step
      [notification]="mainService.planNotification"
      [(ngModel)]="FormModel.notificationStep"
      (notificationChange)="notificationChangeHandler($event)"></mbs-notifications-step>
  </mbs-wizard-step>
</mbs-wizard>
